/**
 * Centralized application configuration from environment variables.
 *
 * Single source of truth -- import from here instead of using
 * `import.meta.env` directly in components or modules.
 */

export const config = {
    appName: import.meta.env.VITE_APP_NAME || 'FNL Platform',
    apiUrl: import.meta.env.VITE_API_URL || '',
    registrationMode: (import.meta.env.VITE_REGISTRATION_MODE ||
        'invite_only') as 'open' | 'invite_only',
} as const;

/** Whether public (non-invite) registration is enabled. */
export const isRegistrationOpen = config.registrationMode === 'open';
